import React from 'react'
import '../styles/css/experience.css'

const Experience = () => {
  return (
    <div className="experience">
        <div className="ewrapper">
            <div className="econtainer">
                <div className="eflex">
                    <div className="eTexts">
                        <h2 className="eTitle"><span className="eCounter">03. </span> &nbsp;&nbsp;&nbsp;&nbsp; Experience & Schooling</h2>
                        <div className="experiences">
                            <div className="exp">
                                <h2 className="eOneTitle">Samoei Boys Secondary School, Nandi Hills</h2>
                                <div className="eOneTexts">
                                    <p>at samoei i learned alot of life skills and career developing skills through my four years there, This is where i had my first intrest in computers</p>
                                    <span className="eduration">2016 Jan - 2019 Dec</span>
                                </div>
                            </div>
                            <div className="exp">
                                <h2 className="eOneTitle">Alphax College, Eldoret</h2>
                                <div className="eOneTexts">
                                    <p>here i took a practical course on web development where i gained skills in HTML, css, javascript and php. I also got certified in web development</p>
                                    <span className="eduration">2020 Jan - 2020 April</span>
                                </div>
                            </div>
                            <div className="exp">
                                <h2 className="eOneTitle">Machackos University, Machackos</h2>
                                <div className="eOneTexts">
                                    <p>I am currently at Machackos University persuing a course in computer science. So far so good here</p>
                                    <span className="eduration">2020 Sept - current</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Experience